export class SessionStorageWrapper {
  protected prefix = "UCRemote";

  setValue(key: string, value: unknown, expire: number | null = null) {
    const item = {
      value,
      expire,
    };
    sessionStorage.setItem(this.getId(key), JSON.stringify(item));
  }

  getValue(key: string): unknown {
    const rawStored = sessionStorage.getItem(this.getId(key));
    if (!rawStored) {
      return null;
    }
    const stored = JSON.parse(rawStored);
    if (!stored) {
      return null;
    }
    if (stored.expire && stored.expire < Date.now()) {
      return null;
    }
    return stored.value;
  }

  clearValue(key: string) {
    sessionStorage.removeItem(this.getId(key));
  }

  protected getId(key: string) {
    return `${this.prefix}.${key}`;
  }
}

const sStorageWrapper = new SessionStorageWrapper();
export default sStorageWrapper;
